import axios from "axios";
import CommonUtil from "../../Util/CommonUtils";
import Toast from "../../components/ToastContainer/CustomToast";
import store from "../../config/configureStore";
import { startLoader, stopLoader } from "../../slices/Loader/LoaderSlice";
import { REACT_LOGIN } from "../../actions/EndPoints";

export const exportCustomerLogs = (
    onSuccess,
    onFailure,
    filter,
    searchParam
  ) => async (dispatch) => {
    store.dispatch(startLoader());
    var typeFile = ''
    if (filter.fileType === '0') {
        typeFile = 'PDF'
    } else if (filter.fileType === '1') {
        typeFile = 'XLSX'
    } else if (filter.fileType === '2') {
        typeFile = 'CSV'
    } else {
        alert('Not selected')
    }
    const buildQueryCheckIn = (filter) => {
      let query =
        "?fileType=" + typeFile + "&fromPage=" + filter?.from + '&toPage=' +filter?.to;
      return query;
    };
  
    axios({
      url: "/web/api/v4/customers/records/export" + buildQueryCheckIn(filter) + searchParam,
      method: "get",
      headers: {
        "Content-type": "application/json",
        Authorization: localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
        companyId: localStorage.getItem("companyId"),
        "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      responseType: "blob",
    }).then((response) => {
      try {
        if (response.status !== 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Customer' + '.'+`${typeFile}`); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link)
          onSuccess();
        } else {
          Toast("No Records Found", "error");
        }
      } catch {
        onFailure();
      }
      
   store.dispatch(stopLoader());
    }).catch((error) => {
      if (error.response && error.response.status === 401 && window.location.pathname !== REACT_LOGIN) {
        window.location = REACT_LOGIN; // Redirect if unauthorized
      } else {
        Toast("Something went wrong.", "error");
      }
      onFailure();
    })
    .finally(() => {
      store.dispatch(stopLoader());
    });
  };


  export const exportCustomerDetailsLogs = (
    onSuccess,
    onFailure,
    filter,
    searchParam
  ) => async (dispatch) => {
    store.dispatch(startLoader());
    var typeFile = ''
    if (filter.fileType === '0') {
        typeFile = 'PDF'
    } else if (filter.fileType === '1') {
        typeFile = 'XLSX'
    } else if (filter.fileType === '2') {
        typeFile = 'CSV'
    } else {
        alert('Not selected')
    }
    const buildQueryCheckIn = (filter) => {
      let query =
        "?fileType=" + typeFile + "&fromPage=" + filter?.from + '&toPage=' +filter?.to;
      return query;
    };
  
    axios({
      url: "/web/api/v4/customers/reports/export" + buildQueryCheckIn(filter) + searchParam,
      method: "get",
      headers: {
        "Content-type": "application/json",
        Authorization: localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
        companyId: localStorage.getItem("companyId"),
        "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      responseType: "blob",
    }).then((response) => {
      try {
        if (response.status !== 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Customer Details' + '.'+`${typeFile}`); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link)
          onSuccess();
        } else {
          Toast("No Records Found", "error");
        }
      } catch {
        onFailure();
      }
      
   store.dispatch(stopLoader());
    }).catch((error) => {
      if (error.response && error.response.status === 401 && window.location.pathname !== REACT_LOGIN) {
        window.location = REACT_LOGIN; // Redirect if unauthorized
      } else {
        Toast("Something went wrong.", "error");
      }
      onFailure();
    })
    .finally(() => {
      store.dispatch(stopLoader());
    });
  };

  export const exportPurchaseListLogs = (
    onSuccess,
    onFailure,
    filter,
    searchParam
  ) => async (dispatch) => {
    store.dispatch(startLoader());
    var typeFile = ''
    if (filter.fileType === '0') {
        typeFile = 'PDF'
    } else if (filter.fileType === '1') {
        typeFile = 'XLSX'
    } else if (filter.fileType === '2') {
        typeFile = 'CSV'
    } else {
        alert('Not selected')
    }
    const buildQueryCheckIn = (filter) => {
      let query =
        "?fileType=" + typeFile + "&fromPage=" + filter?.from + '&toPage=' +filter?.to;
      return query;
    };
  
    axios({
      url: "/web/api/v4/subscriptions/purchase/export" + buildQueryCheckIn(filter) + searchParam,
      method: "get",
      headers: {
        "Content-type": "application/json",
        Authorization: localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
        companyId: localStorage.getItem("companyId"),
        "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      responseType: "blob",
    }).then((response) => {
      try {
        if (response.status !== 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Purchase plan' + '.'+`${typeFile}`); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link)
          onSuccess();
        } else {
          Toast("No Records Found", "error");
        }
      } catch {
        onFailure();
      }
      
   store.dispatch(stopLoader());
    }).catch((error) => {
      if (error.response && error.response.status === 401 && window.location.pathname !== REACT_LOGIN) {
        window.location = REACT_LOGIN; // Redirect if unauthorized
      } else {
        Toast("Something went wrong.", "error");
      }
      onFailure();
    })
    .finally(() => {
      store.dispatch(stopLoader());
    });
  };

  export const exportDealerLogs = (
    onSuccess,
    onFailure,
    filter,
    searchParam
  ) => async (dispatch) => {
    store.dispatch(startLoader());
    var typeFile = ''
    if (filter.fileType === '0') {
        typeFile = 'PDF'
    } else if (filter.fileType === '1') {
        typeFile = 'XLSX'
    } else if (filter.fileType === '2') {
        typeFile = 'CSV'
    } else {
        alert('Not selected')
    }
    const buildQueryCheckIn = (filter) => {
      let query =
        "?fileType=" + typeFile + "&fromPage=" + filter?.from + '&toPage=' +filter?.to;
      return query;
    };
  
    axios({
      url: "/web/api/v4/dealers/records/export" + buildQueryCheckIn(filter) + searchParam,
      method: "get",
      headers: {
        "Content-type": "application/json",
        Authorization: localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
        companyId: localStorage.getItem("companyId"),
        "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      responseType: "blob",
    }).then((response) => {
      try {
        if (response.status !== 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Dealer' + '.'+`${typeFile}`); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link)
          onSuccess();
        } else {
          Toast("No Records Found", "error");
        }
      } catch {
        onFailure();
      }
      
   store.dispatch(stopLoader());
    }).catch((error) => {
      if (error.response && error.response.status === 401 && window.location.pathname !== REACT_LOGIN) {
        window.location = REACT_LOGIN; // Redirect if unauthorized
      } else {
        Toast("Something went wrong.", "error");
      }
      onFailure();
    })
    .finally(() => {
      store.dispatch(stopLoader());
    });;
  };


  export const exportCustomerBydealerId = (
    onSuccess,
    onFailure,
    filter,
    id,
    searchParam
  ) => async (dispatch) => {
    store.dispatch(startLoader());
    var typeFile = ''
    if (filter.fileType === '0') {
        typeFile = 'PDF'
    } else if (filter.fileType === '1') {
        typeFile = 'XLSX'
    } else if (filter.fileType === '2') {
        typeFile = 'CSV'
    } else {
        alert('Not selected')
    }
    const buildQueryCheckIn = (filter) => {
      let query =
        "?fileType=" + typeFile + "&fromPage=" + filter?.from + '&toPage=' +filter?.to;
      return query;
    };
  
    axios({
      url: "/web/api/v4/customers/reports/export/"+id + buildQueryCheckIn(filter)+searchParam,
      method: "get",
      headers: {
        "Content-type": "application/json",
        Authorization: localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
        companyId: localStorage.getItem("companyId"),
        "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      responseType: "blob",
    }).then((response) => {
      try {
        if (response.status !== 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Customer Details' + '.'+`${typeFile}`); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link)
          onSuccess();
        } else {
          Toast("No Records Found", "error");
        }
      } catch {
        onFailure();
      }
      
   store.dispatch(stopLoader());
    }).catch((error) => {
      if (error.response && error.response.status === 401 && window.location.pathname !== REACT_LOGIN) {
        window.location = REACT_LOGIN; // Redirect if unauthorized
      } else {
        Toast("Something went wrong.", "error");
      }
      onFailure();
    })
    .finally(() => {
      store.dispatch(stopLoader());
    });
  };


  export const exportReportDealerLogs = (
    onSuccess,
    onFailure,
    filter,
    searchParam
  ) => async (dispatch) => {
    store.dispatch(startLoader());
    var typeFile = ''
    if (filter.fileType === '0') {
        typeFile = 'PDF'
    } else if (filter.fileType === '1') {
        typeFile = 'XLSX'
    } else if (filter.fileType === '2') {
        typeFile = 'CSV'
    } else {
        alert('Not selected')
    }
    const buildQueryCheckIn = (filter) => {
      let query =
        "?fileType=" + typeFile + "&fromPage=" + filter?.from + '&toPage=' +filter?.to;
      return query;
    };
  
    axios({
      url: "/web/api/v4/dealers/records/export" + buildQueryCheckIn(filter) + searchParam,
      method: "get",
      headers: {
        "Content-type": "application/json",
        Authorization: localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
        companyId: localStorage.getItem("companyId"),
        "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      responseType: "blob",
    }).then((response) => {
      try {
        if (response.status !== 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Dealer Transaction Details' + '.'+`${typeFile}`); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link)
          onSuccess();
        } else {
          Toast("No Records Found", "error");
        }
      } catch {
        onFailure();
      }
      
   store.dispatch(stopLoader());
    }).catch((error) => {
      if (error.response && error.response.status === 401 && window.location.pathname !== REACT_LOGIN) {
        window.location = REACT_LOGIN; // Redirect if unauthorized
      } else {
        Toast("Something went wrong.", "error");
      }
      onFailure();
    })
    .finally(() => {
      store.dispatch(stopLoader());
    });
  };

  export const exportHqCustomerLogs = (
    onSuccess,
    onFailure,
    filter,
    searchParam
  ) => async (dispatch) => {
    store.dispatch(startLoader());
    var typeFile = ''
    if (filter.fileType === '0') {
        typeFile = 'PDF'
    } else if (filter.fileType === '1') {
        typeFile = 'XLSX'
    } else if (filter.fileType === '2') {
        typeFile = 'CSV'
    } else {
        alert('Not selected')
    }
    const buildQueryCheckIn = (filter) => {
      let query =
        "?fileType=" + typeFile + "&fromPage=" + filter?.from + '&toPage=' +filter?.to;
      return query;
    };
  
    axios({
      url: "/web/api/v4/customers/reports/export" + buildQueryCheckIn(filter) + searchParam,
      method: "get",
      headers: {
        "Content-type": "application/json",
        Authorization: localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
        companyId: localStorage.getItem("companyId"),
        "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      responseType: "blob",
    }).then((response) => {
      try {
        if (response.status !== 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Customer Transaction Details' + '.'+`${typeFile}`); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link)
          onSuccess();
        } else {
          Toast("No Records Found", "error");
        }
      } catch {
        onFailure();
      }
      
   store.dispatch(stopLoader());
    }).catch((error) => {
      if (error.response && error.response.status === 401 && window.location.pathname !== REACT_LOGIN) {
        window.location = REACT_LOGIN; // Redirect if unauthorized
      } else {
        Toast("Something went wrong.", "error");
      }
      onFailure();
    })
    .finally(() => {
      store.dispatch(stopLoader());
    });
  };


  export const exportDealerReportsLogs = (
    onSuccess,
    onFailure,
    filter,
    searchParam
  ) => async (dispatch) => {
    store.dispatch(startLoader());
    var typeFile = ''
    if (filter.fileType === '0') {
        typeFile = 'PDF'
    } else if (filter.fileType === '1') {
        typeFile = 'XLSX'
    } else if (filter.fileType === '2') {
        typeFile = 'CSV'
    } else {
        alert('Not selected')
    }
    const buildQueryCheckIn = (filter) => {
      let query =
        "?fileType=" + typeFile + "&fromPage=" + filter?.from + '&toPage=' +filter?.to;
      return query;
    };
  
    axios({
      url: "/web/api/v4/dealers/reports/export" + buildQueryCheckIn(filter) + searchParam,
      method: "get",
      headers: {
        "Content-type": "application/json",
        Authorization: localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
        companyId: localStorage.getItem("companyId"),
        "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      responseType: "blob",
    }).then((response) => {
      try {
        if (response.status !== 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Dealer' + '.'+`${typeFile}`); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link)
          onSuccess();
        } else {
          Toast("No Records Found", "error");
        }
      } catch {
        onFailure();
      }
      
   store.dispatch(stopLoader());
    }).catch((error) => {
      if (error.response && error.response.status === 401 && window.location.pathname !== REACT_LOGIN) {
        window.location = REACT_LOGIN; // Redirect if unauthorized
      } else {
        Toast("Something went wrong.", "error");
      }
      onFailure();
    })
    .finally(() => {
      store.dispatch(stopLoader());
    });
  };
  